// extracted by mini-css-extract-plugin
export default {"emphasized":"NavigationElement-n7gq0__emphasized"};